var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.768 19.359C34.578 19.132 34.297 19 34 19H28V15C28 14.448 27.553 14 27 14H24C23.6 14 23.238 14.238 23.081 14.605L20.341 21H20C20 20.448 19.553 20 19 20H15C14.447 20 14 20.448 14 21V31C14 31.552 14.447 32 15 32H19C19.553 32 20 31.552 20 31V30.478L23.629 31.929C23.746 31.976 23.873 32 24 32H32C32.483 32 32.897 31.654 32.984 31.179L34.984 20.179C35.037 19.887 34.957 19.587 34.768 19.359ZM18 30H16V22H18V30ZM31.166 30H24.192L20 28.323V23H21C21.4 23 21.762 22.762 21.919 22.394L24.659 16H26V20C26 20.552 26.447 21 27 21H32.802L31.166 30Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "thumbs-up.57fa517d15dd436a879f6b331bd31aeb.svg";